export const getProductAddOns = (product) => {
    const addOns =
        product.catalog && product.catalog.items.length > 0
            ? getMerchandiseCatalogItems(product).map((catalogItem) =>
                  transformCatalogItemToAddOn(catalogItem, product),
              )
            : product.addOns;

    return addOns.filter((addOn) => addOn.visibility !== "private") || [];
};

const getMerchandiseCatalogItems = (product) => {
    return product.catalog.items.filter((catalogItem) => {
        return catalogItem.unitType === "merchandise";
    });
};

const transformCatalogItemToAddOn = (catalogItem, product) => {
    return {
        id: catalogItem.id,
        object: catalogItem.type,
        name: catalogItem.name,
        choices: (catalogItem.items && catalogItem.items.map((item) => ({ id: item.id, name: item.name }))) || [],
        sequence: catalogItem.sequence,
        photo: catalogItem.photo,
        desc: catalogItem.caption,
        code: getCode(catalogItem, product), //X2
    };
};

// Get respective X1 Id as code for Migrated sellers
const getCode = (item, product) => {
    let code = null;

    if (product.addOns) {
        if (item.type === "choices") {
            const choiceCode = item.items.length > 0 ? item.items[0].template.code : null;
            // X1
            const oldChoiceAddon = product.addOns.find(
                (addOn) =>
                    addOn.object &&
                    addOn.object === "choices" &&
                    addOn.choices &&
                    (addOn.choices.some((choice) => choice.id === choiceCode) || addOn.name === item.name),
            );
            code = oldChoiceAddon ? oldChoiceAddon.id : null;
        } else {
            code = item.template.code;
        }
    }

    return code;
};
